import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=85f3d098&"
import script from "./VTable.vue?vue&type=script&lang=js&"
export * from "./VTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports